import moment from 'moment';
import { detectBrowser } from 'Core/data/Helpers'

export const getTimeFrame = (timeFrame) => {
    const quarter = moment().quarter();
    let options = {
        today: {
            start: moment().startOf('day').toDate(),
            end: moment.max(moment()).endOf('day').toDate()
        },
        yesterday: {
            start: moment().subtract(1, 'days').startOf('day').toDate(),
            end: moment.max(moment().subtract(1, 'days')).endOf('day').toDate()
        },
        week: {
            start: moment().day(0).startOf('day').toDate(),
            end: moment.max(moment()).endOf('day').toDate()
        },
        lastWeek: {
            start: moment().day(-7).startOf('day').toDate(),
            end: moment().day(-1).endOf('day').toDate()
        },
        thisMonth: {
            start: moment().startOf('month').toDate(),
            end: moment.max(moment()).endOf('day').toDate()
        },
        lastMonth: {
            start: moment(moment()).subtract(1, 'months').startOf('month').toDate(),
            end: moment(moment()).subtract(1, 'months').endOf('month').toDate()
        },
        quarter: {
            start: moment().startOf('quarter').toDate(),
            end: moment.max(moment()).endOf('day').toDate()
        },
        lastQuarter: {
            start: moment().quarter(quarter - 1).startOf('quarter').toDate(),
            end: moment().quarter(quarter - 1).endOf('quarter').toDate()
        }
    }

    return options[timeFrame] || options['week'];
}

export const getAuditLogsActions = (messages) => {
    let types = [
        { value: "insert", label: messages['insert'] || "Insert" },
        { value: "update", label: messages['update'] || "Update" },
        { value: "delete", label: messages['delete'] || "Delete" },
        { value: "other", label: messages['other'] || "Other" }
    ];
    return types;
}

export const passwordValidation = (value) => {
    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
    return re.test(value);
}

export const generatePassword = (length) => {
    let characters = "ABCDEFGHIJKLMNPQRTUVW1234567890abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ1234567890abcdefghijkmnpqrtuvwxyz";
    let password = "";
    for (let i = 0; i < length; i++) {
        password += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return password
}

export const downloadFile = (link) => {
    if (link) {
        if (Array.isArray(link) && link.length > 1) {
            return [true, { urlsDownload: link }]
        } else {
            const newLink = Array.isArray(link) ? link[0]?.url : link
            const url = newLink.includes("http") ? newLink : `https://${newLink}`;
            if (detectBrowser() === 'Firefox') {
                window.open(url, '_blank')
            } else {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.click();
                document.body.removeChild(a);
            }
            return [false, {}]
        }
    }
}

/**
 * Truncates text to a specified maximum length with ellipsis.
 * Useful for displaying long content (like raw messages) in table cells
 * while keeping the full content available in modals/tooltips.
 * 
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length before truncation (default: 200)
 * @returns {string} - Truncated text with '...' suffix if exceeded maxLength, or original text
 */
export const truncateText = (text, maxLength = 200) => {
    if (!text || typeof text !== 'string') return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

export const getCsvDelimiter = (headerLine) => {
    const commaCount = ((headerLine || '').match(/,/g) || []).length;
    const semicolonCount = ((headerLine || '').match(/;/g) || []).length;
    return semicolonCount > commaCount ? ';' : ',';
}